import { useI18nContext } from "@hopper-b2b/i18n";

export const useFilterUserRating = () => {
  const { t } = useI18nContext();
  const options = [
    {
      toggleValue: "0",
      title: t("core-hotels.availabilityPage.filters.userRating.any"),
    },
    {
      toggleValue: "0.7",
      title: t("core-hotels.availabilityPage.filters.userRating.veryGood"),
    },
    {
      toggleValue: "0.9",
      title: t("core-hotels.availabilityPage.filters.userRating.excellent"),
    },
  ];

  return { options };
};
